import { PRUDENCE_MICRO_BRAND, PRUDENCE_MICRO_HOSTS } from './campaign';

export const plansData = [
  {
    id: 'esencial',
    tag: 'Plan 1 · Esencial',
    title: 'Presencia constante en entornos digitales y editoriales',
    monthlyEur: 120,
    highlight: false,
    features: [
      'TNO Digest: dos (2) artículos semanales (8 al mes) optimizados para SEO en tnonetwork.com.',
      'Redes sociales: dos (2) inserts o menciones al mes en plataformas digitales de TNO Network (compartidas).',
      'Señal en vivo: inserts gráficos (lower thirds) rotativos en 2do Escalón.',
    ],
    idealFor:
      'Ideal para mantener presencia constante en entornos digitales y editoriales con inversión de entrada.',
  },
  {
    id: 'desarrollo',
    tag: 'Plan 2 · Desarrollo',
    title: 'Segundo escalón — recomendado',
    monthlyEur: 220,
    highlight: true,
    features: [
      'TNO Digest: dos (2) artículos semanales (8 al mes) con enlaces de interés.',
      `Micros en rotativa: emisión diaria de «${PRUDENCE_MICRO_BRAND}» (30 s), con humor y cercanía, a cargo de ${PRUDENCE_MICRO_HOSTS}, en la grilla Radio Visual y 2do Escalón.`,
      'Presencia selectiva: espacio y banners patrocinados en 2do Escalón, con apoyo de micros «Minuto Prudence» a cargo de Karla Aleska y Mariana.',
      'Redes sociales: cuatro (4) inserts o clips de video al mes co-publicados entre TNO y la marca.',
    ],
    idealFor:
      'Mayor cobertura audiovisual combinando rotativa, 2do Escalón y contenido editorial en un solo despliegue.',
  },
  {
    id: 'premium',
    tag: 'Plan 3 · Premium',
    title: 'Máximo alcance multiplataforma',
    monthlyEur: 350,
    highlight: false,
    features: [
      'TNO Digest: dos (2) artículos semanales (8 al mes) con posicionamiento destacado en el home del portal.',
      `Micros en rotativa: alta rotación diaria de «${PRUDENCE_MICRO_BRAND}» con ${PRUDENCE_MICRO_HOSTS} (tono educativo + humor) en toda la grilla audiovisual y 2do Escalón.`,
      'Presencia total en 2do Escalón: integración orgánica en antena, bloques con Karla Aleska y Mariana e inserts visuales en vivo.',
      'Entrevista especializada: una (1) entrevista de 1 bloque al mes en estudio (vocero de marca o especialista), moderada por el equipo de 2do Escalón.',
      'Redes sociales: cobertura multiplataforma con clips de alta calidad, historias semanales y carruseles informativos.',
    ],
    idealFor:
      'Dominio absoluto de la señal con 2do Escalón, entrevistas en estudio y máxima frecuencia editorial y social.',
  },
];

export const formatEur = (amount) =>
  `${Number(amount).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
